import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// Header X-TENANT-ID por-request: a tela de gestão da organização opera sobre UM tenant,
// então o header vai na própria chamada em vez de mutar apiService.defaults.headers.common
// (que é global e vazaria entre seções/telas). Sem tenantId, herda o default.
const tenantConfig = (tenantId?: string) =>
  tenantId ? { headers: { 'X-TENANT-ID': tenantId } } : undefined

export const getIntegracao = async (
  tenantId?: string
): Promise<GetIntegracaoType | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/integracao/config',
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getExecutarIntegracao = async (
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/integracao/sync',
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return { info: 'Integração executada com sucesso' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getExecutarEnriquecimento = async (
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/integracao/enriquecimento',
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return { info: 'Enriquecimento iniciado com sucesso' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getExecutarClienteVendedor = async (
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/integracao/cliente-vendedor',
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      // "Solicitada", não "concluída": o endpoint é fire-and-forget (roda async e responde 200
      // na hora), então o 200 não diz nada sobre o resultado da sincronização.
      return {
        info: 'Sincronização de cliente x vendedor solicitada — o processamento segue em segundo plano',
      }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const salvarIntegracao = async (
  organizacaoRequestDTO: SalvarIntegracaoRequestType,
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      'app/integracao/config',
      {
        ...organizacaoRequestDTO,
      },
      tenantConfig(tenantId)
    )
    if (result.status === 200) {
      return { info: 'Integração salva com sucesso!' }
    }
    if (result.status === 201) {
      return { info: 'Integração criada com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
